import { OptimizationMode as k } from "./optimizer.service.js";
const et = 50;
async function it(i, l) {
  if (!i)
    throw new Error("Optimizer service is not initialized");
  const { medias: L, refineSpend: G } = i, b = JSON.parse(i.recentYearSpends), { startDate: p, endDate: h } = l.getPeriod(b), B = JSON.parse(i.recentYearMediumTotalSpends), H = await i.getMediasLimits();
  let I = Promise.resolve();
  const A = async (t) => {
    let e;
    const a = new Promise((r) => {
      e = r;
    }), s = I;
    I = a, await s;
    try {
      return await t();
    } finally {
      e();
    }
  };
  let V = 0, m = null, D = null;
  const E = async () => await G(Object.values(B).reduce((t, e) => t + e, 0)), M = await E(), q = () => {
    const t = i.diminishing;
    return L.reduce(
      (e, a, s) => (t[s] !== void 0 && (e[a] = t[s]), e),
      {}
    );
  }, Q = () => JSON.parse(i.allocation), y = async () => {
    await i.resetOptimisationRules();
  }, j = async (t) => {
    await i.updateRules(t);
  }, $ = async (t) => {
    const e = t.filter((a) => a.type === "Allowed weekdays");
    for (const a of e)
      try {
        const s = JSON.parse(a.value);
        Array.isArray(s) && s.length === 7 && await i.setAllowedWeekdays(a.channel, s);
      } catch {
      }
  }, X = async () => await i.readMessages(), f = (t) => {
    if (t)
      return t instanceof Date ? t : l.parseDate(t);
  }, _ = (t) => {
    const e = String(t.getDate()).padStart(2, "0"), a = String(t.getMonth() + 1).padStart(2, "0"), s = t.getFullYear();
    return `${e}-${a}-${s}`;
  }, Z = (t, e) => {
    const a = f(t);
    if (!a || !e || e <= 0)
      return { startDate: p, endDate: h };
    const s = new Date(a);
    return s.setDate(s.getDate() + e - 1), {
      startDate: _(a),
      endDate: _(s)
    };
  }, R = async (t, e, a, s) => {
    const r = a?.configRules || [], n = a?.variables;
    return r.length === 0 && (!n || Object.keys(n).length === 0) ? s() : A(async () => {
      const o = Z(t, e), u = l.prepareRules(n, r, o.startDate, o.endDate);
      await y();
      try {
        if (u.length > 0) {
          await $(u);
          const d = u.filter((O) => O.type !== "Allowed weekdays");
          d.length > 0 && await j(d);
        }
        return await s();
      } finally {
        await y();
      }
    });
  }, K = async (t, e, a) => {
    const s = a?.scalePeriods ?? !0;
    return await R(t, e, a, async () => {
      const r = f(t), [n, o] = await i.getKPILimits(r, e, s);
      return { lower: n, upper: o };
    });
  }, N = async (t, e, a) => await R(t, e, a, async () => {
    const s = f(t), [r, n] = await i.getBudgetLimits(s, e);
    return {
      lower: r + et,
      upper: n
    };
  }), Y = async (t, e, a) => {
    const s = a?.scalePeriods ?? !0;
    return await R(t, e, a, async () => {
      const r = f(t), [n, o] = await i.getTotalKPILimits(r, e, s);
      return { lower: n, upper: o };
    });
  }, J = async (t, e, a, s) => t === "budget" ? N(e, a, s) : t === "total_kpi" ? Y(e, a, s) : K(e, a, s), S = async (t, e, a, s, r) => {
    const n = ++V;
    if (D = n, D !== n)
      throw new Error(`Optimization ${n} was batched`);
    m = n, D = null;
    let o = k.BUDGET;
    s === "media_kpi" ? o = k.MEDIA_KPI : s === "total_kpi" && (o = k.TOTAL_KPI);
    try {
      const u = await i.createOptimisedPlans(
        t,
        e ? l.parseDate(e) : void 0,
        a ? l.parseDate(a) : void 0,
        o,
        r
      );
      if (m !== n)
        throw new Error(`Optimization ${n} was superseded`);
      return u;
    } finally {
      m === n && (m = null);
    }
  }, z = (t) => ({
    lowestBudgetTrustworthiness: t * (1 - l.budgetTrustworthinessThreshold),
    highestBudgetTrustworthiness: t * (1 + l.budgetTrustworthinessThreshold)
  });
  return {
    getOptimizedPlan: async (t) => A(async () => {
      const {
        budget: e,
        variables: a,
        configRules: s = [],
        startDate: r,
        endDate: n,
        optimizationBase: o
      } = t;
      await y();
      let { budget: u, budgetError: d } = await l.checkBudget(e, i, M, o);
      const O = r && n ? Math.max(
        1,
        Math.round(
          (l.parseDate(n).getTime() - l.parseDate(r).getTime()) / (1e3 * 60 * 60 * 24)
        ) + 1
      ) : void 0, P = l.prepareRules(a, s, r || p, n || h), W = P.some((c) => c.type === "Set active days to"), x = o || "budget", C = { scalePeriods: !W }, [T, F] = await Promise.all([
        J(x, r, O, C),
        i.getMediasLimits()
      ]);
      if (P.length > 0) {
        await $(P);
        const c = P.filter((g) => g.type !== "Allowed weekdays");
        c.length > 0 && await j(c);
      }
      const U = await J(x, r, O, C), w = T;
      u < w.lower ? (d = `Entered ${o === "budget" ? "budget" : "target"} was too low. Changed it to lowest possible which is ${w.lower}.`, u = w.lower) : u > w.upper && (d = `Entered ${o === "budget" ? "budget" : "target"} was too high. Changed it to highest possible which is ${w.upper}.`, u = w.upper);
      const tt = await S(u, r, n, o, !W);
      let v = F;
      if (r && n) {
        const c = l.getDurationRatio(r, n);
        v = F.map((g) => ({
          ...g,
          lowerLimit: Math.round(g.lowerLimit * c),
          upperLimit: Math.round(g.upperLimit * c)
        }));
      }
      return {
        ...l.buildOptimizationOutput({ plan: tt, medias: L, recentYearSpends: b }),
        ...z(M),
        recentYearMediumTotalSpends: B,
        recentYearSpends: b,
        budget: u,
        defaultBudget: M,
        lowestBudget: U.lower,
        highestBudget: U.upper,
        unconstrainedLowestBudget: T.lower,
        unconstrainedHighestBudget: T.upper,
        budgetError: d,
        startDate: p,
        endDate: h,
        mediaLimits: v,
        investmentStep: i.investmentStep,
        naturalDemand: l.formatNaturalDemand(await i.getNaturalDemandData())
      };
    }),
    messages: X,
    getDiminishingPoints: q,
    getInitialAllocation: Q,
    resetOptimisationRules: y,
    getDefaultBudget: E,
    getBudgetLimits: N,
    getKPILimits: K,
    getTotalKPILimits: Y,
    startDate: p,
    endDate: h,
    getOptimizerVersion: () => i.getOptimizerVersion(),
    getActiveDaysPerMedium: () => i.getActiveDaysPerMedium(),
    getBaseProjectMediaLimits: () => H,
    medias: L
  };
}
export {
  it as createOptimizerServiceManager
};
